(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('root-cause-analysis', {
            parent: 'functions_menu',
            url: '/root-cause-analysis?page&sort&search',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysis.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analyses.html',
                    controller: 'RootCauseAnalysisController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'created,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysis');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('anomalyEvent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('root-cause-analysis-detail', {
            parent: 'functions_menu',
            url: '/root-cause-analysis/detail/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS'],
                pageTitle: 'abcQualityMatchApp.rootCauseAnalysis.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-detail.html',
                    controller: 'RootCauseAnalysisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rootCauseAnalysis');
                    $translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('ticket');
                    $translatePartialLoader.addPart('ticketMaterial');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('information');
                    $translatePartialLoader.addPart('informationEvent');
                    $translatePartialLoader.addPart('questionnaireType');
                    $translatePartialLoader.addPart('anomalyEvent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RootCauseAnalysis', function($stateParams, RootCauseAnalysis) {
                    return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'root-cause-analysis',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('root-cause-analysis-detail.edit', {
            parent: 'root-cause-analysis-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis.new', {
            parent: 'root-cause-analysis',
            url: '/new?inf&aes',
            param:{
                inf:{
                    array : true,
                }
            },
            
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        
                        
                        entity: 
                            function () {
                                return {
                                    created: new Date(),
                                    factorsDescription: null,
                                    factors: [],
                                    id: null,
                                    issue: null,
                                    causes:[],
                                    rootCauseDescription: null,
                                    company: {},
                                    correctiveActionPlan: null,
                                    correctiveProjectId: null,
                                    correctiveTasktId:null,
                                    author:null,
                                    informationEvents: [],
                                    anomalyEvents:[],
                                    
                                    linkToInformationIds : $stateParams.inf,
                                    linkToAnomalyEventIds : $stateParams.aes
                                };
                            }
                        
                       }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('root-cause-analysis');
                });
            }]
        })
        
       
        
        
        .state('root-cause-analysis.edit', {
            parent: 'root-cause-analysis',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-dialog.html',
                    controller: 'RootCauseAnalysisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('root-cause-analysis.delete', {
            parent: 'root-cause-analysis',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN', 'ROOT_CAUSE_ANALYSIS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/analysis/root-cause-analysis/root-cause-analysis-delete-dialog.html',
                    controller: 'RootCauseAnalysisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RootCauseAnalysis', function(RootCauseAnalysis) {
                            return RootCauseAnalysis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('root-cause-analysis', null, { reload: 'root-cause-analysis' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
    

})();
